/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deft_Wise_Gull_RestInputs */

const en_deft_wise_gull_rest = /** @type {(inputs: Deft_Wise_Gull_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments enabled`)
};

const de_deft_wise_gull_rest = /** @type {(inputs: Deft_Wise_Gull_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare aktiviert`)
};

/**
* | output |
* | --- |
* | "Comments enabled" |
*
* @param {Deft_Wise_Gull_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_wise_gull_rest = /** @type {((inputs?: Deft_Wise_Gull_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Wise_Gull_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_wise_gull_rest(inputs)
	return de_deft_wise_gull_rest(inputs)
});